import React, { forwardRef } from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./alert-badge.module.scss";
const cx = c.bind(styles);

export const ALERT_BADGE_VARIANT = {
  ATTENTION: "attention",
  INFORMATION: "information",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  NEUTRAL: "neutral",
} as const;

export const alertBadgeVariants = Object.values(ALERT_BADGE_VARIANT);
export type AlertBadgeVariant = (typeof ALERT_BADGE_VARIANT)[keyof typeof ALERT_BADGE_VARIANT];

export type AlertBadgeProps = Omit<BaseProps<"span">, "children"> & {
  variant: AlertBadgeVariant;
};

const rootClassName = "purpur-alert-badge";

export const AlertBadge = forwardRef<HTMLSpanElement, AlertBadgeProps>((props, ref) => {
  const { className, variant, ...otherProps } = props;
  const classes = cx([rootClassName, `${rootClassName}--${variant}`, className]);

  return <span {...otherProps} className={classes} ref={ref} />;
});

AlertBadge.displayName = "AlertBadge";
